import settings from '../../services/settings'

export default {
  computed: {
    getSettings () {
      return settings
    }
  }
}
